import { render, staticRenderFns } from "./chatList.vue?vue&type=template&id=08b835de&"
import script from "./chatList.vue?vue&type=script&lang=ts&"
export * from "./chatList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports